import React, { useContext } from 'react'
import styled from 'styled-components'
import { CreationToolsContext } from '../../../manager'
import CreationTool from '../../../types/creation-tool'

const Gradient = styled.div<{ colors: string[] }>`
    background: ${props => `linear-gradient(45deg, ${props.colors[0]} 0%, ${props.colors[1]} 100%)`};
    border-radius: inherit;
    height: 100%;
    left: 0;
    opacity: 0.9;
    position: absolute;
    top: 0;
    width: 100%;
`

const CreationToolsWelcomeGradient = () => {
    const { tool } = useContext(CreationToolsContext)
    const gradient = CreationTool.gradient(tool)
    return <Gradient colors={gradient} />
}

export default CreationToolsWelcomeGradient
